import axios from '../utils/axios';

export const track = (data) => {
	return axios.post('/api/track-event', data);
};
 
